import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ModalService } from 'src/services/modal.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrls: ['./yes-no-modal.component.scss']
})
export class YesNoModalComponent implements OnInit, OnDestroy {

  destroy$ = new Subject<any>();
  
  @ViewChild('modal')
  modal : ElementRef;

  title = '';
  message = '';
  modalRef : NgbModalRef;

  constructor(private modalService : ModalService, private ngbModal : NgbModal) { }

  ngOnInit() {
    this.modalService.onYesNoRequested$.pipe(takeUntil(this.destroy$)).subscribe(a => {
      this.title = a.title;
      this.message = a.message;
      this.ngbModal.open(this.modal).result.then(
        r => {
          if (!a.onYes) return;
          a.onYes();
        }, 
        r => {
          if (!a.onNo) return;
          a.onNo();
        });
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

}
